import { gql } from '@apollo/client';

export const CREATE_SIP_SETTING_MUTATION = gql`
  mutation CreateSipSettingMutation($input: CreateSipSettingInput!) {
    createSipSetting(input: $input) {
      ID
      domain
      isEnabled
      password
      type
      username
    }
  }
`;
